import {FC} from 'react';
import {IonText} from '@ionic/react';

type UILogoProps = {
  style?: string;
}

const UILogo: FC<UILogoProps> = ({style}) => {
  return (
    <IonText color="primary"
      className={`${style ? style : 'text-right text-sm leading-2'} text-navy-primary font-Outfit font-bold`}>
      <div>TATTOO<br/>DECLARATION<br/>APP</div>
    </IonText>
  );
};

export default UILogo;
